import React, { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import { ConsentProvider } from '../components/ConsentContext';
import lang from '../data/translations.json';
import { getLanguageFromPath } from '../utils/languages';
import { setAnalyticsUserProperties } from '../utils/analytics';

const queryClient = new QueryClient();

const MasterLayout = ({ children, path, location }) => {
  const currentPath = path ?? location?.pathname ?? '';
  const languageCode = getLanguageFromPath(currentPath);
  const translate = lang[languageCode] || lang.en;

  useEffect(() => {
    setAnalyticsUserProperties({ locale: languageCode });
  }, [languageCode]);

  useEffect(() => {
    document.body.dataset.homeDesign = 'game';
  }, []);

  return (
    <ConsentProvider translate={translate}>
      <Nav path={currentPath} translate={translate} />
      <QueryClientProvider client={queryClient}>
        {children}
      </QueryClientProvider>
      <Footer translate={translate} />
    </ConsentProvider>
  );
};

export default MasterLayout;
